<template>
<section class="quiz">
  <div class="quiz-body">
    <header class="quiz-body__header">
      <p v-if="quizStat ===1">Вопрос 1: <span>Какой размер помещения вашего проекта?</span></p>
      <p v-if="quizStat ===2">Вопрос 2: <span>Какой стиль лучше подходит для вашего проекта?</span></p>
      <p v-if="quizStat ===3">Вопрос 3: <span>Когда примерно планируете начать работы над проектом?</span></p>
      <div v-if="quizStat ===4">Завершение</div>
      <button class="close" @click="quizClose ()" v-if="quizStat !== 5"><span></span></button>
    </header>
    <form class="quiz-body__content">
      <div class="quiz-1" v-if="quizStat ===1">
        <div class="quiz-1__row">
          <input type="radio" id="quiz-radio-1" name="quiz-1" value="1" v-model="paramQuiz.area">
          <label for="quiz-radio-1" class="quiz-1__col">
            <span class="col__body">
              <span>от 50 до 80 м²</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-2" name="quiz-1" value="2" v-model="paramQuiz.area">
          <label for="quiz-radio-2" class="quiz-1__col">
            <span class="col__body">
              <span>от 80 до 120 м²</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-3" name="quiz-1" value="3" v-model="paramQuiz.area">
          <label for="quiz-radio-3" class="quiz-1__col">
            <span class="col__body">
              <span>более 120 м²</span>
            </span>
          </label>
        </div>
      </div>
      <div class="quiz-2" v-if="quizStat ===2">
        <div class="quiz-2__row">
          <input type="radio" id="quiz-radio-4" name="quiz-2" value="1" v-model="paramQuiz.style">
          <label for="quiz-radio-4" class="quiz-2__col">
            <span class="col__body">
              <span class="image">
                <picture>
                  <source srcset="../../public/static/images/quiz/1.webp">
                  <img src="../../public/static/images/quiz/1.jpg" alt="">
                </picture>
              </span>
              <span>Минимализм</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-5" name="quiz-2" value="2" v-model="paramQuiz.style">
          <label for="quiz-radio-5" class="quiz-2__col">
            <span class="col__body">
              <span class="image">
                <picture>
                  <source srcset="../../public/static/images/quiz/2.webp">
                  <img src="../../public/static/images/quiz/2.jpg" alt="">
                </picture>
              </span>
              <span>Скандинавский стиль</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-6" name="quiz-2" value="3" v-model="paramQuiz.style">
          <label for="quiz-radio-6" class="quiz-2__col">
            <span class="col__body">
              <span class="image">
                <picture>
                  <source srcset="../../public/static/images/quiz/3.webp">
                  <img src="../../public/static/images/quiz/3.jpg" alt="">
                </picture>
              </span>
              <span>Стиль Лофт</span>
            </span>
          </label>
        </div>
      </div>
      <div class="quiz-3" v-if="quizStat ===3">
        <div class="quiz-3__row">
          <input type="radio" id="quiz-radio-7" name="quiz-3" value="1" v-model="paramQuiz.time">
          <label for="quiz-radio-7" class="quiz-3__col">
            <span class="col__body">
              <span>Уже нужно</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-8" name="quiz-3" value="2" v-model="paramQuiz.time">
          <label for="quiz-radio-8" class="quiz-3__col">
            <span class="col__body">
              <span>В течении месяца</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-9" name="quiz-3" value="3" v-model="paramQuiz.time">
          <label for="quiz-radio-9" class="quiz-3__col">
            <span class="col__body">
              <span>В течении недели</span>
            </span>
          </label>
          <input type="radio" id="quiz-radio-10" name="quiz-3" value="4" v-model="paramQuiz.time">
          <label for="quiz-radio-10" class="quiz-3__col">
            <span class="col__body">
              <span>Более 3-ех месяцев</span>
            </span>
          </label>
        </div>
      </div>
      <div class="quiz-4" v-if="quizStat ===4">
        <div class="quiz-4__row">
          <div class="col-5">
            <div class="input-group">
              <input type="text" id="quiz-text-1" placeholder="Введите ваш номер телефона">
              <label for="quiz-text-1"></label>
            </div>
            <div class="input-group">
              <input type="text" id="quiz-text-2" placeholder="Введите ваш E-mail">
              <label for="quiz-text-2"></label>
            </div>
          </div>
          <div class="col-5">
            <p>Заполните ваши данные для обратной связи и мы вам позвоним</p>
            <button class="button__yellow button_small" @click="quizPlus ()">Оставить заявку</button>
          </div>
        </div>
      </div>
      <div class="quiz-5" v-if="quizStat === 5">
        <div class="text">
          Спасибо за заявку!
          <button class="button__transparent button_small" @click="quizClose">Закрыть</button>
        </div>
      </div>
    </form>
    <footer class="quiz-body__footer"  v-if="quizStat !== 5">
      <button class="button__transparent button_small btn_back" @click="quizMinus ()" v-if="quizStat > 1">
        Назад
      </button>
      <div class="pagination">
        <span v-bind:class="{active: quizStat ===1}"></span>
        <span v-bind:class="{active: quizStat ===2}"></span>
        <span v-bind:class="{active: quizStat ===3}"></span>
        <span v-bind:class="{active: quizStat ===4}"></span>
      </div>
      <button class="button__transparent button_small btn_next" @click="quizPlus ()" v-if="quizStat < 4">
        Далее
      </button>
      <button class="button__transparent button_small btn_next" @click="quizReset ()" v-if="quizStat === 4">
        Сбросить все
      </button>
    </footer>
  </div>
  <div class="quiz-bg"></div>
</section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SectionQuiz',
  components: {},
  methods: {
    ...mapActions ([
        'closeQuiz',
        'minusQuiz',
        'plusQuiz',
        'resetQuiz'
    ]),
    quizClose () {
      this.closeQuiz()
    },
    quizPlus () {
      this.plusQuiz()
    },
    quizMinus () {
      this.minusQuiz()
    },
    quizReset () {
      this.resetQuiz()
    }
  },
  computed: {
    ...mapGetters ([
        'quizStat',
        'paramQuiz'
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.quiz {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
  &-body {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 80vw;
    min-width: 300px;
    height: 80vh;
    min-height: 300px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    padding: 50px 100px;
    @media (max-width: 1199.98px) {
      width: 100%;
      height: 100%;
      overflow: scroll;
      padding: 30px 10px;
    }
    @media (max-width: 997.98px) {
      overflow-x: hidden;
    }
    &__header {
      display: flex;
      justify-content: space-between;
      @media (max-width: 997.98px) {
        padding-bottom: 20px;
        padding-top: 40px;
      }
      p {
        font-weight: 900;
        font-size: 2rem;
        span {
          font-weight: 500;
          font-size: 1.8rem;
          color: #333333;
        }
      }
      div {
        font-weight: 900;
        font-size: 3.6rem;
      }
      .close {
        position: relative;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        padding: 0;
        @media (max-width: 575.98px) {
          margin-left: 20px;
        }
        span {
          position: relative;
          width: 100%;
          height: 100%;
          content: '';
          display: block;
          top: 0;
          right: 0;
          &:after, &:before {
            position: absolute;
            width: 30px;
            height: 2px;
            content: '';
            background-color: #000000;
            top: 50%;
            right: 0;
          }
          &:after {
            transform: rotate(45deg);
          }
          &:before {
            transform: rotate(-45deg);
          }
        }
      }
    }
    &__content {
      flex: 1 1 auto;
      .quiz-1 {
        height: 100%;
        &__row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          margin: 0 -40px;
          @media (max-width: 997.98px) {
            justify-content: center;
          }
          input {
            display: none;
            &:checked+label {
              .col__body {
                border-color: #FAFF09;
              }
            }
          }
        }
        &__col {
          flex: 0 0 33.333%;
          max-width: 33.333%;
          height: 30vh;
          box-sizing: border-box;
          padding: 0 40px;
          position: relative;
          @media (max-width: 997.98px) {
            flex: 0 0 80%;
            max-width: 80%;
            margin-bottom: 20px;
            height: 100px;
          }
          @media (max-width: 575.98px) {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .col__body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border: 15px solid #4F4F4F;
            cursor: pointer;
            font-weight: 300;
            font-size: 2rem;
            overflow: hidden;
            box-sizing: border-box;
            @media (max-width: 997.98px) {
              border: 5px solid #4f4f4f;
            }
          }
        }
      }
      .quiz-2 {
        height: 100%;
        &__row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          margin: 0 -40px;
          @media (max-width: 997.98px) {
            justify-content: center;
          }
          input {
            display: none;
            &:checked+label {
              .col__body {
                .image {
                  border-color: #FAFF09;
                }
              }
            }
          }
        }
        &__col {
          flex: 0 0 33.333%;
          max-width: 33.333%;
          height: 30vh;
          box-sizing: border-box;
          padding: 0 40px;
          position: relative;
          @media (max-width: 997.98px) {
            flex: 0 0 80%;
            max-width: 80%;
            margin-bottom: 20px;
            height: 120px;
          }
          @media (max-width: 575.98px) {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .col__body {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 100%;
            cursor: pointer;
            font-weight: 300;
            font-size: 2rem;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            span:last-child {
              margin-top: 10px;
            }
            .image {
              flex: 1 1 auto;
              width: 100%;
              position: relative;
              border: 15px solid #4F4F4F;
              box-sizing: border-box;
              overflow: hidden;
              @media (max-width: 997.98px) {
                border: 5px solid #4f4f4f;
              }
              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                object-position: center;
              }
            }
          }
        }
      }
      .quiz-3 {
        height: 100%;
        &__row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          margin: 0 -40px;
          @media (max-width: 997.98px) {
            justify-content: center;
          }
          input {
            display: none;
            &:checked+label {
              .col__body {
                border-color: #FAFF09;
              }
            }
          }
        }
        &__col {
          flex: 0 0 50%;
          max-width: 50%;
          height: 10vh;
          box-sizing: border-box;
          padding: 0 40px;
          position: relative;
          @media (max-width: 997.98px) {
            flex: 0 0 80%;
            max-width: 80%;
            margin-bottom: 20px;
            height: 100px;
          }
          @media (max-width: 575.98px) {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .col__body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border: 5px solid #4F4F4F;
            cursor: pointer;
            font-weight: 300;
            font-size: 2rem;
            overflow: hidden;
            box-sizing: border-box;
            @media (max-width: 997.98px) {
              padding: 20px 0;
            }
          }
        }
      }
      .quiz-4 {
        &__row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          height: 100%;
          margin: 0 -40px;
          @media (max-width: 997.98px) {
            justify-content: center;
          }
          .col-5 {
            display: flex;
            flex-direction: column;
            padding: 0 40px;
            flex: 0 0 50%;
            max-width: 50%;
            justify-content: space-between;
            @media (max-width: 997.98px) {
              flex: 0 0 80%;
              max-width: 80%;
              margin-bottom: 20px;
              height: auto;
            }
            @media (max-width: 575.98px) {
              flex: 0 0 100%;
              max-width: 100%;
            }
            .input-group {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
            }
            p {
              font-weight: 500;
              font-size: 2rem;
              color: #333333;
              margin-bottom: 20px;
            }
            input[type="text"] {
              border: 1px solid #E0E0E0;
              box-sizing: border-box;
              font-weight: 300;
              font-size: 1.6rem;
              color: #0E0E0E;
              width: 100%;
              padding: 15px 20px;
              height: auto;
              &::placeholder {
                font-weight: 200;
                font-size: 1.6rem;
                color: #4F4F4F;
              }
            }
            button {
              font-size: 1.6rem;
              font-weight: 300;
            }
          }
        }
      }
      .quiz-5 {
        .text {
          font-size: 3rem;
          font-weight: 300;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          button {
            margin-top: 30px;
          }
        }
      }
    }
    &__footer {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      height: 59px;
      box-sizing: border-box;
      padding: 30px 0;
      @media (max-width: 575.98px) {
        flex-wrap: wrap;
      }
      button {
        font-weight: 300;
        font-size: 1.6rem;
        display: flex;
        @media (max-width: 575.98px) {
          flex: 0 0 100%;
          max-width: 100%;
          margin-top: 20px;
        }
        &.btn_next {
          position: absolute;
          bottom: 0;
          right: 0;
          @media (max-width: 575.98px) {
            position: relative;
          }
          @media (max-width: 575.98px) {
            order: 1;
          }
        }
        &.btn_back {
          position: absolute;
          bottom: 0;
          left: 0;
          @media (max-width: 575.98px) {
            position: relative;
          }
          @media (max-width: 575.98px) {
            order: 2;
          }
        }
      }
      .pagination {
        display: flex;
        @media (max-width: 575.98px) {
          flex: 0 0 100%;
          max-width: 100%;
          margin-top: 20px;
          justify-content: center;
          order: 3;
          padding-bottom: 50px;
        }
        span {
          display: block;
          width: 15px;
          height: 15px;
          background: #4F4F4F;
          margin-right: 20px;
          transition: .1s linear all;
          @media (max-width: 575.98px) {
            width: 10px;
            height: 10px;
          }
          &.active {
            background-color: #FAFF09;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .6;
  }
}
</style>
